import { render, staticRenderFns } from "./HKLAttachment.vue?vue&type=template&id=b3221924&scoped=true&"
import script from "./HKLAttachment.vue?vue&type=script&lang=js&"
export * from "./HKLAttachment.vue?vue&type=script&lang=js&"
import style0 from "./HKLAttachment.vue?vue&type=style&index=0&id=b3221924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3221924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3221924')) {
      api.createRecord('b3221924', component.options)
    } else {
      api.reload('b3221924', component.options)
    }
    module.hot.accept("./HKLAttachment.vue?vue&type=template&id=b3221924&scoped=true&", function () {
      api.rerender('b3221924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Upload/HKLAttachment.vue"
export default component.exports